//MAIN
import * as React from 'react';
import CookieConsent, { Cookies } from "react-cookie-consent";
import { connect } from 'react-redux';

// COMPONENTS
import Modal from '../Modal';


// TYPES
import { Store } from '../../types'

// styles 
import './styles.scss'


const bc = 'cookies'

type Props = {
  settings: any
}

type State = {
  openModal: boolean
}

//STYLES FOR COMPONENTS
const stylesButton = {
  fontFamily: "OpenSans, arial, sans-serif",
    color: "#FFFFFF",
    fontSize: "14px",
    fontWeight: "bold",   
    background: "#000000",
    boxSizing: "border-box",
    padding: '4px 10px 4px 10px',
    margin: '0px',
    textAlign: "center",
    transition: "background 0.3s",
    "hover": {
      background: "#3E9B67"
    }
}

const stylesContainer = {
  minHeight: '20px',
  boxSizing: 'border-box',
  opacity: '0.8',
  padding: '8px 10px 8px 10px',
  background: '#232323',
  overflow: 'hidden'
}
//


class Cookies extends React.Component<Props,State>{ 
   
  state = {
    openModal: false
  }

   handleAction = () => {
    this.setState((prv)=>({
      openModal: !prv.openModal 
    }))
  };

 render(){  
  const { settings : {gdpr_content , gdpr_bar_text} } = this.props;
  const { openModal } = this.state;

  return (
    <CookieConsent
        location="bottom"
        buttonText="Ok, jag förstår"
        cookieName="myAwesomeCookieName2"
        containerClasses = {'containerClasses'}
        contentClasses={'contentClasses'}
        style={stylesContainer}
        buttonStyle={stylesButton}
        buttonClasses = {'buttonClasses'}
        expires={150}
        >
        <div className={bc + "__text"}>{gdpr_bar_text}<div className={bc + "__button"} onClick={this.handleAction}>{'Läs detaljer'}</div></div>
       
        <Modal gdpr_content={gdpr_content} handleAction={this.handleAction} openModal={openModal}/>
    </CookieConsent>
);
} 
}

const mapStateToProps = (state: Store)=>{
    return {        
        settings: state.settings
    }
};

export default connect<any,any, any>(mapStateToProps)(Cookies);